import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {
  inputSelector: '[data-datepicker-input]',
};

export default class InlineDatePicker extends Component {
  static selector = '[data-comp-datepicker]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.inputElement = this.$container.querySelector(
      this.$options.inputSelector
    );

    window.$(this.$options.inputSelector).datepicker({ autoclose: true });
  }
}
